export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [3,5,6,4];

export const dictionary = {
		"/(internal)": [8,[3]],
		"/(internal)/calendar/[[date]]": [11,[3]],
		"/(blank)/checkin/[uuid]": [7,[2]],
		"/(internal)/clients": [13,[3]],
		"/(internal)/client/[uuid]": [12,[3,5]],
		"/(internal)/create/project/thankyou/[[uuid]]": [14,[3]],
		"/(internal)/create/project/[[step]]": [15,[3]],
		"/(internal)/documents": [16,[3]],
		"/(internal)/employees": [~22,[3]],
		"/(internal)/employees/list": [~23,[3]],
		"/(internal)/employee/[uuid]": [~17,[3,6]],
		"/(internal)/employee/[uuid]/connect": [18,[3,6]],
		"/(internal)/employee/[uuid]/dokumente": [~19,[3,6]],
		"/(internal)/employee/[uuid]/old": [20,[3,6]],
		"/(internal)/employee/[uuid]/vertrag": [~21,[3,6]],
		"/(internal)/logout": [~24,[3]],
		"/(internal)/(project)/projects": [10,[3,4]],
		"/(internal)/(project)/project/[uuid]": [9,[3,4]],
		"/(internal)/sales": [25,[3]],
		"/(internal)/settings": [26,[3]],
		"/(internal)/settings/access": [~27,[3]],
		"/(internal)/settings/batch": [28,[3]],
		"/(internal)/settings/cost-center": [29,[3]],
		"/(internal)/settings/mailing": [30,[3]],
		"/(internal)/settings/profile": [31,[3]],
		"/(internal)/settings/tariffs": [32,[3]],
		"/(internal)/settings/templates": [33,[3]],
		"/(internal)/settings/units": [34,[3]],
		"/(internal)/telephone-interview": [35,[3]],
		"/(internal)/test": [36,[3]],
		"/(internal)/ui": [37,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';